import { createTranslationModule } from '@/hooks/use-component-translation/utils'

import deDe from './deDe.json'
import enUs from './enUs.json'
import esEs from './esEs.json'
import frFr from './frFr.json'
import itIt from './itIt.json'
import ptBr from './ptBr.json'

export default createTranslationModule({
  path: 'lib/page-titles',
  translations: {
    enUs,
    ptBr,
    esEs,
    frFr,
    deDe,
    itIt,
  },
})
